module.exports = __webpack_public_path__ + "static/media/abhindrakrishna.a02eaa33.jpg";